import { FC, useEffect, useState, ReactNode } from 'react';
import { ProTreeSelect } from '../antd';
import { formatTreeData } from './util';
import { TreeSelectProps } from 'antd/lib/tree-select';
import { ChangeEventExtra } from 'rc-tree-select/lib/interface';
import { SUCCESS_STATUS_CODE } from '../constants/constant';

export type ValueType = string | string[];
export interface DataNode {
  value?: string | number;
  title?: React.ReactNode;
  label?: React.ReactNode;
  key?: string | number;
  disabled?: boolean;
  disableCheckbox?: boolean;
  checkable?: boolean;
  children?: DataNode[];
  /** Customize data info */
  [prop: string]: any;
}
/** 下拉选择树 */
export interface SuperTreeSelectProps
  extends Omit<TreeSelectProps<any>, 'onChange'> {
  /** 当前选中的值 */
  value?: ValueType;
  /** 是否所有节点都可以选中 */
  allSelect?: boolean;
  /** 远程接口 */
  fetchApi?: (params: any) => Promise<any>;
  /** 接口默认参数 */
  defaultParams?: any;
  /** 搜索字段 */
  searchKey?: string;
  /** title对应字段 */
  titleKey?: string;
  /** value对应字段 */
  valueKey?: string;
  /** children对应字段 */
  childrenKey?: string;
  /** 是否多选 */
  multiple?: boolean;
  /** onChange */
  onChange?: (
    value: any,
    labelList: ReactNode[],
    extra: ChangeEventExtra,
    treeValues: any[],
  ) => void;
}
/** 下拉树 */
export const SuperTreeSelect: FC<SuperTreeSelectProps> = props => {
  const {
    fetchApi,
    onChange,
    value,
    allSelect,
    defaultParams,
    searchKey,
    showSearch,
    titleKey,
    valueKey,
    childrenKey,
    allowClear,
    ...resProps
  } = props;
  const [selectValue, setSelectValue] = useState<ValueType>();
  const [treeData, setTreeData] = useState<any[]>([]);
  const fetch = (val?: string) => {
    const params = defaultParams ? { ...defaultParams } : {};
    if (searchKey && val) {
      params[searchKey] = val;
    }
    fetchApi?.(params).then(res => {
      if (res.code === SUCCESS_STATUS_CODE) {
        setTreeData(
          formatTreeData(res.data, titleKey, valueKey, childrenKey, allSelect),
        );
      }
    });
  };
  useEffect(() => {
    fetch();
  }, [defaultParams]);
  useEffect(() => {
    setSelectValue(value);
  }, [value]);
  const handleChange = (
    value: any,
    labelList: ReactNode[],
    extra: ChangeEventExtra,
  ) => {
    setSelectValue(value);
    const treeValues = extra.allCheckedNodes?.map?.(
      // @ts-ignore
      item => item.node?.props?.treeValues || item.props?.treeValues,
    );
    onChange?.(value, labelList, extra, treeValues);
  };
  return (
    <ProTreeSelect
      {...resProps}
      showSearch={showSearch}
      allowClear={allowClear}
      style={{ width: '100%' }}
      value={selectValue}
      treeData={treeData}
      maxTagPlaceholder={omittedValues => {
        return `+${omittedValues.length}`;
      }}
      // @ts-ignore
      onChange={handleChange}
    />
  );
};

SuperTreeSelect.defaultProps = {
  showSearch: false,
  titleKey: 'title',
  childrenKey: 'children',
  multiple: false,
  allowClear: true,
  allSelect: false,
};
export default SuperTreeSelect;
